import React from 'react';
import { connect } from 'react-redux';

import { selectPlan } from '../../../../redux/auth/user/selectors';

import UpgradeSuccessfulAlert from './UpgradeSuccessfulAlert';
import { selectIsVisible } from './selectors';

const UpgradeSuccessfulAlertConnected = (props) => <UpgradeSuccessfulAlert {...props} />;

const mapStateToProps = (state) => ({
  isVisible: selectIsVisible(state),
  plan: selectPlan(state),
});

export default connect(mapStateToProps)(UpgradeSuccessfulAlertConnected);
